import React, { useState, useEffect } from 'react';
import {
  MDBContainer,
  MDBCollapse,
  MDBNavbar,
  MDBNavbarToggler,
  MDBIcon,
  MDBBtn,
} from 'mdb-react-ui-kit';
import ManagerSideBar from './ManagerSideBar';
import './Sidebar.css'

export default function App() {
  const [showNavExternal2, setShowNavExternal2] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1200);
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(true);
    setShowNavExternal2(!showNavExternal2);
    if (sidebarOpen) {
      setTimeout(() => {
        setSidebarOpen(false);
      }, 390);
    }
  };

  return (
    <>
      <MDBContainer fluid>
        <MDBNavbarToggler
          type='button'
          data-target='#navbarToggleExternalContent'
          aria-controls='navbarToggleExternalContent'
          aria-expanded='false'
          aria-label='Toggle navigation'
          onClick={toggleSidebar}
          className= {sidebarOpen ? 'shift-right' : ''}
          color="#fff"
          id='sidebarColor'
          
          
        >
          <MDBIcon
            icon={sidebarOpen ? 'times' : 'bars'}
            // className="sidebarColor" // Change the icon based on the sidebarOpen state
            fas
          />
        </MDBNavbarToggler>
      </MDBContainer>

      <MDBCollapse
        show={showNavExternal2}
        className="position-relative"// Add a class to handle sidebar animation
        style={{ zIndex: 1000, width: '100%' }}
      >
        <ManagerSideBar />
      </MDBCollapse>
    </>
  );
}